var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c(
        "el-col",
        [
          _c(
            "el-form",
            {
              ref: "axisForm",
              attrs: {
                model: _vm.axisForm,
                "label-width": "80px",
                size: "mini",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("show"),
                      expression: "showProperty('show')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.show") },
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      on: {
                        change: function ($event) {
                          return _vm.changeYAxisStyle("show")
                        },
                      },
                      model: {
                        value: _vm.axisForm.show,
                        callback: function ($$v) {
                          _vm.$set(_vm.axisForm, "show", $$v)
                        },
                        expression: "axisForm.show",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.show")))]
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.axisForm.show,
                      expression: "axisForm.show",
                    },
                  ],
                },
                [
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("position"),
                          expression: "showProperty('position')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.position") },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { size: "mini" },
                          on: {
                            change: function ($event) {
                              return _vm.changeYAxisStyle("position")
                            },
                          },
                          model: {
                            value: _vm.axisForm.position,
                            callback: function ($$v) {
                              _vm.$set(_vm.axisForm, "position", $$v)
                            },
                            expression: "axisForm.position",
                          },
                        },
                        [
                          _c("el-radio-button", { attrs: { label: "left" } }, [
                            _vm._v(_vm._s(_vm.$t("chart.text_pos_left"))),
                          ]),
                          _c("el-radio-button", { attrs: { label: "right" } }, [
                            _vm._v(_vm._s(_vm.$t("chart.text_pos_right"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("name"),
                          expression: "showProperty('name')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.name") },
                    },
                    [
                      _c("el-input", {
                        attrs: { size: "mini" },
                        on: {
                          blur: function ($event) {
                            return _vm.changeYAxisStyle("name")
                          },
                        },
                        model: {
                          value: _vm.axisForm.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.axisForm, "name", $$v)
                          },
                          expression: "axisForm.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("nameTextStyle"),
                          expression: "showProperty('nameTextStyle')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.axis_name_color") },
                    },
                    [
                      _c("el-color-picker", {
                        staticClass: "color-picker-style",
                        attrs: { predefine: _vm.predefineColors },
                        on: {
                          change: function ($event) {
                            return _vm.changeYAxisStyle("nameTextStyle")
                          },
                        },
                        model: {
                          value: _vm.axisForm.nameTextStyle.color,
                          callback: function ($$v) {
                            _vm.$set(_vm.axisForm.nameTextStyle, "color", $$v)
                          },
                          expression: "axisForm.nameTextStyle.color",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("nameTextStyle"),
                          expression: "showProperty('nameTextStyle')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.axis_name_fontsize") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: _vm.$t("chart.axis_name_fontsize"),
                          },
                          on: {
                            change: function ($event) {
                              return _vm.changeYAxisStyle("nameTextStyle")
                            },
                          },
                          model: {
                            value: _vm.axisForm.nameTextStyle.fontSize,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.axisForm.nameTextStyle,
                                "fontSize",
                                $$v
                              )
                            },
                            expression: "axisForm.nameTextStyle.fontSize",
                          },
                        },
                        _vm._l(_vm.fontSize, function (option) {
                          return _c("el-option", {
                            key: option.value,
                            attrs: { label: option.name, value: option.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("axisValue"),
                          expression: "showProperty('axisValue')",
                        },
                      ],
                    },
                    [
                      _c("el-divider"),
                      _c(
                        "el-form-item",
                        { staticClass: "form-item" },
                        [
                          _c(
                            "span",
                            { attrs: { slot: "label" }, slot: "label" },
                            [
                              _c(
                                "span",
                                { staticClass: "span-box" },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.$t("chart.axis_value"))),
                                  ]),
                                  _c(
                                    "el-tooltip",
                                    {
                                      staticClass: "item",
                                      attrs: {
                                        effect: "dark",
                                        placement: "bottom",
                                      },
                                    },
                                    [
                                      _c("div", {
                                        attrs: { slot: "content" },
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$t("chart.axis_tip")
                                          ),
                                        },
                                        slot: "content",
                                      }),
                                      _c("i", {
                                        staticClass: "el-icon-info",
                                        staticStyle: { cursor: "pointer" },
                                      }),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                          _c(
                            "el-checkbox",
                            {
                              on: {
                                change: function ($event) {
                                  return _vm.changeYAxisStyle("axisValue")
                                },
                              },
                              model: {
                                value: _vm.axisForm.axisValue.auto,
                                callback: function ($$v) {
                                  _vm.$set(_vm.axisForm.axisValue, "auto", $$v)
                                },
                                expression: "axisForm.axisValue.auto",
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("chart.axis_auto")))]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.axisForm.axisValue.auto,
                              expression: "!axisForm.axisValue.auto",
                            },
                          ],
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "form-item",
                              attrs: { label: _vm.$t("chart.axis_value_min") },
                            },
                            [
                              _c("el-input", {
                                on: {
                                  blur: function ($event) {
                                    return _vm.changeYAxisStyle("axisValue")
                                  },
                                },
                                model: {
                                  value: _vm.axisForm.axisValue.min,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.axisForm.axisValue, "min", $$v)
                                  },
                                  expression: "axisForm.axisValue.min",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "form-item",
                              attrs: { label: _vm.$t("chart.axis_value_max") },
                            },
                            [
                              _c("el-input", {
                                on: {
                                  blur: function ($event) {
                                    return _vm.changeYAxisStyle("axisValue")
                                  },
                                },
                                model: {
                                  value: _vm.axisForm.axisValue.max,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.axisForm.axisValue, "max", $$v)
                                  },
                                  expression: "axisForm.axisValue.max",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { staticClass: "form-item" },
                            [
                              _c(
                                "span",
                                { attrs: { slot: "label" }, slot: "label" },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "span-box" },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "chart.axis_value_split_count"
                                            )
                                          )
                                        ),
                                      ]),
                                      _c(
                                        "el-tooltip",
                                        {
                                          staticClass: "item",
                                          attrs: {
                                            effect: "dark",
                                            placement: "bottom",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              attrs: { slot: "content" },
                                              slot: "content",
                                            },
                                            [
                                              _vm._v(
                                                "\n                      期望的坐标轴刻度数量，非最终结果。\n                    "
                                              ),
                                            ]
                                          ),
                                          _c("i", {
                                            staticClass: "el-icon-info",
                                            staticStyle: { cursor: "pointer" },
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _c("el-input", {
                                on: {
                                  blur: function ($event) {
                                    return _vm.changeYAxisStyle("axisValue")
                                  },
                                },
                                model: {
                                  value: _vm.axisForm.axisValue.splitCount,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.axisForm.axisValue,
                                      "splitCount",
                                      $$v
                                    )
                                  },
                                  expression: "axisForm.axisValue.splitCount",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.showProperty("splitLine") ? _c("el-divider") : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("splitLine"),
                          expression: "showProperty('splitLine')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.axis_show") },
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          on: {
                            change: function ($event) {
                              return _vm.changeYAxisStyle("axisLine")
                            },
                          },
                          model: {
                            value: _vm.axisForm.axisLine.show,
                            callback: function ($$v) {
                              _vm.$set(_vm.axisForm.axisLine, "show", $$v)
                            },
                            expression: "axisForm.axisLine.show",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("chart.axis_show")))]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("splitLine"),
                          expression: "showProperty('splitLine')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.grid_show") },
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          on: {
                            change: function ($event) {
                              return _vm.changeYAxisStyle("splitLine")
                            },
                          },
                          model: {
                            value: _vm.axisForm.splitLine.show,
                            callback: function ($$v) {
                              _vm.$set(_vm.axisForm.splitLine, "show", $$v)
                            },
                            expression: "axisForm.splitLine.show",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("chart.grid_show")))]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.showProperty("splitLine") &&
                            _vm.axisForm.splitLine.show,
                          expression:
                            "showProperty('splitLine') && axisForm.splitLine.show",
                        },
                      ],
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "form-item",
                          attrs: { label: _vm.$t("chart.grid_color") },
                        },
                        [
                          _c("el-color-picker", {
                            staticClass: "el-color-picker",
                            attrs: { predefine: _vm.predefineColors },
                            on: {
                              change: function ($event) {
                                return _vm.changeYAxisStyle("splitLine")
                              },
                            },
                            model: {
                              value: _vm.axisForm.splitLine.lineStyle.color,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.axisForm.splitLine.lineStyle,
                                  "color",
                                  $$v
                                )
                              },
                              expression: "axisForm.splitLine.lineStyle.color",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "form-item form-item-slider",
                          attrs: { label: _vm.$t("chart.grid_width") },
                        },
                        [
                          _c("el-slider", {
                            attrs: {
                              min: 1,
                              max: 10,
                              "show-input": "",
                              "show-input-controls": false,
                              "input-size": "mini",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.changeYAxisStyle("splitLine")
                              },
                            },
                            model: {
                              value: _vm.axisForm.splitLine.lineStyle.width,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.axisForm.splitLine.lineStyle,
                                  "width",
                                  $$v
                                )
                              },
                              expression: "axisForm.splitLine.lineStyle.width",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.showProperty("axisLabel") ? _c("el-divider") : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("axisLabel"),
                          expression: "showProperty('axisLabel')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.axis_label_show") },
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          on: {
                            change: function ($event) {
                              return _vm.changeYAxisStyle("axisLabel")
                            },
                          },
                          model: {
                            value: _vm.axisForm.axisLabel.show,
                            callback: function ($$v) {
                              _vm.$set(_vm.axisForm.axisLabel, "show", $$v)
                            },
                            expression: "axisForm.axisLabel.show",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("chart.axis_label_show")))]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.showProperty("axisLabel") &&
                            _vm.axisForm.axisLabel.show,
                          expression:
                            "showProperty('axisLabel') && axisForm.axisLabel.show",
                        },
                      ],
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "form-item",
                          attrs: { label: _vm.$t("chart.axis_label_color") },
                        },
                        [
                          _c("el-color-picker", {
                            staticClass: "el-color-picker",
                            attrs: { predefine: _vm.predefineColors },
                            on: {
                              change: function ($event) {
                                return _vm.changeYAxisStyle("axisLabel")
                              },
                            },
                            model: {
                              value: _vm.axisForm.axisLabel.color,
                              callback: function ($$v) {
                                _vm.$set(_vm.axisForm.axisLabel, "color", $$v)
                              },
                              expression: "axisForm.axisLabel.color",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "form-item form-item-slider",
                          attrs: { label: _vm.$t("chart.axis_label_rotate") },
                        },
                        [
                          _c("el-slider", {
                            attrs: {
                              "show-input": "",
                              "show-input-controls": false,
                              min: -90,
                              max: 90,
                              "input-size": "mini",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.changeYAxisStyle("axisLabel")
                              },
                            },
                            model: {
                              value: _vm.axisForm.axisLabel.rotate,
                              callback: function ($$v) {
                                _vm.$set(_vm.axisForm.axisLabel, "rotate", $$v)
                              },
                              expression: "axisForm.axisLabel.rotate",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "form-item",
                          attrs: { label: _vm.$t("chart.axis_label_fontsize") },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: _vm.$t(
                                  "chart.axis_label_fontsize"
                                ),
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.changeYAxisStyle("axisLabel")
                                },
                              },
                              model: {
                                value: _vm.axisForm.axisLabel.fontSize,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.axisForm.axisLabel,
                                    "fontSize",
                                    $$v
                                  )
                                },
                                expression: "axisForm.axisLabel.fontSize",
                              },
                            },
                            _vm._l(_vm.fontSize, function (option) {
                              return _c("el-option", {
                                key: option.value,
                                attrs: {
                                  label: option.name,
                                  value: option.value,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.chart.type &&
                                !_vm.chart.type.includes("horizontal") &&
                                _vm.chart.type !== "waterfall",
                              expression:
                                "chart.type && !chart.type.includes('horizontal') && chart.type !== 'waterfall'",
                            },
                          ],
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              staticClass: "form-item",
                              attrs: {
                                label: _vm.$t("chart.value_formatter_type"),
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  on: {
                                    change: function ($event) {
                                      return _vm.changeYAxisStyle(
                                        "axisLabelFormatter"
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.axisForm.axisLabelFormatter.type,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.axisForm.axisLabelFormatter,
                                        "type",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "axisForm.axisLabelFormatter.type",
                                  },
                                },
                                _vm._l(_vm.typeList, function (type) {
                                  return _c("el-option", {
                                    key: type.value,
                                    attrs: {
                                      label: _vm.$t("chart." + type.name),
                                      value: type.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.axisForm.axisLabelFormatter.type !==
                                    "auto",
                                  expression:
                                    "axisForm.axisLabelFormatter.type !== 'auto'",
                                },
                              ],
                              staticClass: "form-item",
                              attrs: {
                                label: _vm.$t(
                                  "chart.value_formatter_decimal_count"
                                ),
                              },
                            },
                            [
                              _c("el-input-number", {
                                attrs: {
                                  precision: 0,
                                  min: 0,
                                  max: 10,
                                  size: "mini",
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.changeYAxisStyle(
                                      "axisLabelFormatter"
                                    )
                                  },
                                },
                                model: {
                                  value:
                                    _vm.axisForm.axisLabelFormatter
                                      .decimalCount,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.axisForm.axisLabelFormatter,
                                      "decimalCount",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "axisForm.axisLabelFormatter.decimalCount",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.axisForm.axisLabelFormatter.type !==
                                    "percent",
                                  expression:
                                    "axisForm.axisLabelFormatter.type !== 'percent'",
                                },
                              ],
                              staticClass: "form-item",
                              attrs: {
                                label: _vm.$t("chart.value_formatter_unit"),
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "chart.pls_select_field"
                                    ),
                                    size: "mini",
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.changeYAxisStyle(
                                        "axisLabelFormatter"
                                      )
                                    },
                                  },
                                  model: {
                                    value: _vm.axisForm.axisLabelFormatter.unit,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.axisForm.axisLabelFormatter,
                                        "unit",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "axisForm.axisLabelFormatter.unit",
                                  },
                                },
                                _vm._l(_vm.unitList, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    attrs: {
                                      label: _vm.$t("chart." + item.name),
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "form-item",
                              attrs: {
                                label: _vm.$t("chart.value_formatter_suffix"),
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  size: "mini",
                                  clearable: "",
                                  placeholder: _vm.$t("commons.input_content"),
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.changeYAxisStyle(
                                      "axisLabelFormatter"
                                    )
                                  },
                                },
                                model: {
                                  value: _vm.axisForm.axisLabelFormatter.suffix,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.axisForm.axisLabelFormatter,
                                      "suffix",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "axisForm.axisLabelFormatter.suffix",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "form-item",
                              attrs: {
                                label: _vm.$t(
                                  "chart.value_formatter_thousand_separator"
                                ),
                              },
                            },
                            [
                              _c("el-checkbox", {
                                on: {
                                  change: function ($event) {
                                    return _vm.changeYAxisStyle(
                                      "axisLabelFormatter"
                                    )
                                  },
                                },
                                model: {
                                  value:
                                    _vm.axisForm.axisLabelFormatter
                                      .thousandSeparator,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.axisForm.axisLabelFormatter,
                                      "thousandSeparator",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "axisForm.axisLabelFormatter.thousandSeparator",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }